import { formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/app/environments/environments';
import { StoresService } from 'src/app/shared/services/stores.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { LoggingService } from 'src/app/shared/services/Logging.service';


@Component({
  selector: 'app-shopify',
  templateUrl: './shopify.component.html',
  styleUrls: ['./shopify.component.css'],
  inputs:['body','dialogRef']
})
export class ShopifyComponent implements OnInit {

  ConnectForm: FormGroup;
  @Input() body: any;
  botList: any[] = [];
  storesUrls: any[] = [];
  dialogRef: any;
  channelsList!: { name: string; id: string; image: string; }[];
  readOnlyfield: boolean = false;
  shopUrl: string = '' ;
  router: any;


  constructor(private storeService: StoresService,
    public snackBar: MatSnackBar,private loggingService: LoggingService) {

    this.ConnectForm = new FormGroup({
      shopUrl: new FormControl('', Validators.required),
      ChoosenShopUrl:new FormControl('')
    });
  }

  ngOnInit() {
    this.loggingService.log(this.body,'sxsdcds')
    this.storeService.getStores(this.body.platform, this.body.userID).subscribe(stores => {
      if (stores && stores.length > 0) {

        this.storesUrls = stores.map(store => store.id);
        // stores.map(store => store.id.split(".")[0]);
        // this.loggingService.log(this.storesUrls)
        // this.shopUrl = stores[0].id;
         this.loggingService.log('this.shopUrl',this.storesUrls,this.shopUrl)
   
        // this.ConnectForm.controls.ChoosenShopUrl.setValue(this.shopUrl);
        // this.ConnectForm.controls.shopUrl.setValue(this.shopUrl);
      }
    })

    this.ConnectForm.get("shopUrl")?.valueChanges.subscribe(x => {
      this.loggingService.log('shopUrl value changed')
      this.loggingService.log(x)
      this.shopUrl = x ; 
   })
  }

  get getControls() {
    return this.ConnectForm.controls;
  }

  changeStoreUrlSelected(event) {
    
    this.shopUrl = event.value;
    
  }
  ConnectStorewithSettingNew() {
   this.loggingService.log( 'efzfze',this.body.botType,environment.shopifyPaths.install)
   let typeShopping =  (this.body.botType === 'alexa' ) ? 'voice-shopping' : 'conversational-shopping'
   let atributeShopping =  (this.body.botType === 'alexa' ) ? 'isProductRecoActivated' : 'isConvShoppingActivated'
   if ( this.body.platform != 'custom')
   { 
    this.loggingService.log('this.shopUrl',this.shopUrl)
    this.shopUrl = this.shopUrl.includes('.myshopify.com') ? this.shopUrl : (this.shopUrl += '.myshopify.com');
  

    this.loggingService.log('not custm',this.shopUrl)
    this.storeService.getStoreChannelInfo(this.body.platform,
      typeShopping,
      `${this.shopUrl}`
    ).subscribe(async store => {
      //store is activated
      if (store && store.shopTokenNotifications && !store.deactivate) {
        //update the connected bots to this store
        let connectedBots=(store.connectedBots)?store.connectedBots:{};
        connectedBots[this.body.botType]={
          botID: this.body.botID,
          botName: this.body.botTitle
        }
        let body ={
          connectedBots:connectedBots,
        }
        let bodyBot={
          atributeShopping:store.atributeShopping || firebase.firestore.FieldValue.delete(),
          isProductRecoActivated: store.isProductRecoActivated || firebase.firestore.FieldValue.delete(),
          cmsShop: `${this.shopUrl}`,
          shopID:store.favizoneShopId ||firebase.firestore.FieldValue.delete(),
        }
        //update bot
        this.storeService.updateBotInfo(this.body.botID, bodyBot).then(async bot => {
          //update store
          this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}/appData/${typeShopping}`, body)
          .then(async store => {
        
            this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}`, body)
            .then(async store => {
                  this.snackBar.open("Store connected successfully", "", {
                    duration: 2000,
                    verticalPosition: 'bottom',
                    panelClass: ['green-snackbar']
                  });
                  this.loggingService.log("store connected successfully");
                  this.dialogRef.close();
                }
                , err => {
                  this.snackBar.open("Error connecting store", "", {
                    duration: 2000,
                    verticalPosition: 'bottom',
                    panelClass: ['red-snackbar']
                  });
                  this.dialogRef.close();
                });
            });
        });
      }else{
        //we need to redirect to installation
        this.loggingService.log('not custum1')
        let bodyBot={
          [atributeShopping] : false,
          // isProductRecoActivated:false,
          cmsShop: `${this.shopUrl}`,

        }
        let bodyChannel= {
          accountCreatedwithEmail: this.body.email,
          connectedBots: {
            [this.body.botType]: {
              botID: this.body.botID,
              botName: this.body.botTitle
            }
          },
          userID: this.body.userID,
          flagAleardyConnected: true,
          source: "conversell",
          cron_status: "scheduled",
          connectedSince: new Date(),
          needToConnectBot: false,
        }
        let body={
          primaryChannel: typeShopping,
          userID: this.body.userID,
          source: "conversell",
          connectedBots: {
            [this.body.botType]: {
              botID: this.body.botID,
              botName: this.body.botTitle
            }
          }
        }
        this.storeService.updateBotInfo(this.body.botID, bodyBot).then(async bot => {
          //update store
          this.loggingService.log('not custum3')
          this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}/appData/${typeShopping}`, bodyChannel)
          .then(async store => {
            this.loggingService.log('not custum1 sore',this.shopUrl)
            this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}`, body)
            .then(async store => {
              //this.loggingService.log(`${environment.shopifyProdBaseURL[this.body.botType]}/${environment.shopifyPaths.install}${this.shopUrl}`)
              window.location.href = `${environment.shopifyProdBaseURL[this.body.botType]}/${environment.shopifyPaths.install}${this.shopUrl}`, "_blank";
              this.loggingService.log('not custum2',this.shopUrl)
                  this.snackBar.open("Store connected successfully, we will redirect you to shopify", "", {
                    duration: 2000,
                    verticalPosition: 'bottom',
                    panelClass: ['green-snackbar']
                  });
                  this.dialogRef.close();
                }
                , err => {
                  this.snackBar.open("Error connecting store", "", {
                    duration: 2000,
                    verticalPosition: 'top',
                    panelClass: ['red-snackbar']
                  });
                  this.dialogRef.close();
                });
            });
        });
        //redicrection to installation
      }
    });
  }else 
  {
   
    this.shopUrl = this.extractHostname(this.shopUrl)

    this.storeService.getStoreChannelInfo(this.body.platform,
      typeShopping,
      this.shopUrl
    ).subscribe(async store => {
      //store is activated
      if (store && store.shopTokenNotifications && !store.deactivate) {
        //update the connected bots to this store
        let connectedBots=(store.connectedBots)?store.connectedBots:{};
        connectedBots[this.body.botType]={
          botID:this.body.botID,
          botName:this.body.botTitle
        }
        let body ={
          connectedBots:connectedBots,
          
        }
        let bodyBot={
          isProductRecoActivated:store.isProductRecoActivated || firebase.firestore.FieldValue.delete(),
          cmsShop: this.shopUrl,
          shopID:store.favizoneShopId ||firebase.firestore.FieldValue.delete(),
        }
        //update bot
        this.storeService.updateBotInfo(this.body.botID, bodyBot).then(async bot => {
          this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}/appData/${typeShopping}`, body)
          .then(async store => {   
            this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}`, body)
            .then(async store => {         
                  this.snackBar.open("Store connected successfully", "", {
                    duration: 2000,
                    verticalPosition: 'bottom',
                    panelClass: ['green-snackbar']
                  });
                  this.loggingService.log("store connected successfully");
                  this.dialogRef.close();
                }, err => {
                  this.snackBar.open("Error connecting store", "", {
                    duration: 2000,
                    verticalPosition: 'bottom',
                    panelClass: ['red-snackbar']
                  });
                  this.dialogRef.close();
                });
            });
        });
      }else{
        //we need to redirect to installation
        let bodyBot={
          isProductRecoActivated:false,
          cmsShop: this.shopUrl
        }
        let bodyChannel= {
          accountCreatedwithEmail: this.body.email,
          connectedBots: {
            [this.body.botType]: {
              botID: this.body.botID,
              botName: this.body.botTitle
            }
          },
          userID: this.body.userID,
          flagAleardyConnected: true,
          source: "conversell",
          cron_status: "scheduled",
          connectedSince: new Date(),
          needToConnectBot: false,
          shopName : this.shopUrl,
          shopUrl : this.ConnectForm.controls['shopUrl'].value
        }
        let body={
          userID: this.body.userID,
          primaryChannel: typeShopping,
          source: "conversell",
          plan : 'free',
          connectedSince : formatDate(new Date(), 'DD/MM/YYYY, hh:mm:ss',"en-US"),
          connectedBots: {
            [this.body.botType]: {
              botID: this.body.botID,
              botName: this.body.botTitle
            }
          }
        }
        this.storeService.updateBotInfo(this.body.botID, bodyBot).then(async bot => {
          //update store
          this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}/appData/${typeShopping}`, bodyChannel)
          .then(async store => {
            this.storeService.updateStoreInfoNew(`${this.body.platform}/${this.shopUrl}/`, body)
            .then(async store => {
                
                  this.snackBar.open("Store connected successfully", "", {
                    duration: 2000,
                    verticalPosition: 'bottom',
                    panelClass: ['green-snackbar']
                  });
                  this.dialogRef.close();
                }
                , err => {
                  this.snackBar.open("Error connecting store", "", {
                    duration: 2000,
                    verticalPosition: 'top',
                    panelClass: ['red-snackbar']
                  });
                  this.dialogRef.close();
                });
            });
        });
        //redicrection to installation


      }
    });
  }
  }
  extractHostname(url) {
    var hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname

    if (url.indexOf("//") > -1) {
      hostname = url.split('/')[2];
    } else {
      hostname = url.split('/')[0];
    }

    //find & remove port number
    hostname = hostname.split(':')[0];
    //find & remove "?"
    hostname = hostname.split('?')[0];
    hostname = hostname.replace('www.', '');
    return hostname;
  }

}

